export default function getCookies() {
  if (typeof document === 'undefined') {
    return {};
  }

  var c = document.cookie;
  var v = 0;
  var cookies = {};
  if (document.cookie.match(/^\s*\$Version=(?:"1"|1);\s*(.*)/)) {
    c = RegExp.$1;
    v = 1;
  }
  if (v === 0) {
    c.split(/[,;]/).map(function (cookie) {
      var parts = cookie.split(/=/, 2);
      var name = decodeURIComponent(parts[0].trimStart());
      var value = parts.length > 1 ? decodeURIComponent(parts[1].trimEnd()) : null;
      cookies[name] = value;
    });
  } else {
    c.match(
      /(?:^|\s+)([!#$%&'*+\-.0-9A-Z^`a-z|~]+)=([!#$%&'*+\-.0-9A-Z^`a-z|~]*|"(?:[\x20-\x7E\x80\xFF]|\\[\x20-\x7F])*")(?=\s*[,;]|$)/g
    ).map(function ($0, $1) {
      var name = $0;
      var value = $1.charAt(0) === '"' ? $1.substr(1, -1).replace(/\\(.)/g, '$1') : $1;
      cookies[name] = value;
    });
  }
  return cookies;
}
